import { render } from "./DeleteBooking.vue?vue&type=template&id=4ffe2df9"
import script from "./DeleteBooking.vue?vue&type=script&lang=js"
export * from "./DeleteBooking.vue?vue&type=script&lang=js"
script.render = render

export default script